import { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { useClientPortalPaths } from "../../hooks/useClientPortalBase";
import { previewCommunity } from "../../api/clientPublishingApi";
import {
  ClientPortalError,
  ClientPortalLoading,
} from "../../components/clientPortal/ClientPortalStates";

const ClientCommunityPreviewPage = () => {
  const { clientViewId, communityId } = useParams();
  const [searchParams] = useSearchParams();
  const versionId = searchParams.get("versionId");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const paths = useClientPortalPaths();

  useEffect(() => {
    setLoading(true);
    previewCommunity(clientViewId, communityId, versionId ? { versionId } : {})
      .then(setData)
      .catch((error) => {
        setErrorMessage(error.message || "Unable to load preview.");
      })
      .finally(() => setLoading(false));
  }, [clientViewId, communityId, versionId]);

  if (loading) return <ClientPortalLoading message="Loading preview…" />;
  if (errorMessage) return <ClientPortalError message={errorMessage} />;

  const snapshot = data?.snapshot || {};

  return (
    <>
      <section className="panel-card client-preview-banner" role="status">
        <strong>Preview — not published</strong>
        <p className="muted">This is how the community may appear after approval and publishing.</p>
      </section>

      <section className="panel-card">
        <p className="eyebrow">
          <Link to={paths.viewSection(clientViewId, "communities", communityId, "edit")}>
            Back to edit
          </Link>
        </p>
        <h2>{snapshot.communityName || "Community preview"}</h2>
        {snapshot.shortDescription ? <p>{snapshot.shortDescription}</p> : null}
        {snapshot.longDescription ? (
          <div className="client-preview-body">{snapshot.longDescription}</div>
        ) : null}
        <dl className="client-publishing-panel__meta">
          <dt>Slug</dt>
          <dd>{snapshot.slug || "—"}</dd>
          <dt>Location</dt>
          <dd>
            {[snapshot.city, snapshot.stateRegion, snapshot.country].filter(Boolean).join(", ") ||
              "—"}
          </dd>
          <dt>Display status</dt>
          <dd>{snapshot.displayStatus || "—"}</dd>
        </dl>
      </section>
    </>
  );
};

export default ClientCommunityPreviewPage;
